import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const PlacementSearch = React.lazy(
  () => import('components/Placement/Search/Search'),
);

function ScreensPlacementsList() {
  return (
    <BaseLayout>
      <DocumentTitle>Placements List</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <PlacementSearch />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensPlacementsList;
